import { useQuery } from "@tanstack/react-query";
import type { EmissionRecordView } from "../../apiClient/generated";
import { useUser } from "../../auth";
import { useAdminApiClient } from "../../hooks";

export const useCompanyDataForEmission = ({
    emissionRecord,
}: {
    emissionRecord?: EmissionRecordView;
}) => {
    const adminApiClient = useAdminApiClient();
    const { company: currentUserCompany, isStaff } = useUser();

    // If it's a superuser, fetch company settings for
    // the currently open company.
    const companyDataQuery = useQuery({
        queryKey: ["companyData", emissionRecord?.owner],
        queryFn: async () => {
            return await adminApiClient.adminAccountsCompaniesRetrieve({
                id: emissionRecord.owner,
            });
        },
        refetchOnWindowFocus: false,
        enabled: isStaff && !!emissionRecord,
        staleTime: 0,
    });

    return {
        isLoading: isStaff ? companyDataQuery.isLoading : false,
        company: isStaff ? companyDataQuery.data : currentUserCompany,
    };
};
